



























import { Vue, Component, Prop } from "vue-property-decorator";
import { User as IUser } from "@/api/models/user";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";

@Component({
  components: { CustomTableCol, CustomTableItem }
})
export default class CheckedUsersForInviteItem extends Vue {
  @Prop() user!: IUser;
  @Prop({ default: false }) propChecked?: boolean;

  selectUser() {
    this.$emit("addUser", this.user);
  }
}
